import { MutationFunction, useMutation } from '@tanstack/react-query';
import { createAxiosInstance } from 'api/request';
import { MutationHook } from 'utils/hooks/mutations/types';

type RequestReturnType = void;
type RequestParameters = { name: string };

const request: MutationFunction<RequestReturnType, RequestParameters> = async ({ name }) =>
{
  await createAxiosInstance().post('/logImage', { name: 'AdClick' + name.charAt(0).toUpperCase() + name.substring(1) });
};

const useLogImageClickMutation: MutationHook<RequestReturnType, RequestParameters> = (options) =>
{
  return useMutation({
    mutationFn: request,
    ...options,
  });
};

export default useLogImageClickMutation;